import React from "react";
import EcosystemStore from "src/stores/EcosystemStore";

export interface IRootStore {
  ecosystemStore: EcosystemStore;
}

export class RootStore {
  public ecosystemStore: EcosystemStore;

  constructor() {
    this.ecosystemStore = new EcosystemStore(this);
  }
}

const _rootStore: IRootStore = new RootStore();

export const StoreContext = React.createContext<IRootStore>({} as IRootStore);

interface IProps {
  children: React.ReactNode;
}

export const StoreProvider: React.FC<IProps> = ({ children }) => {
  return (
    <StoreContext.Provider value={_rootStore}>{children}</StoreContext.Provider>
  );
};

export default _rootStore;
